require('../../modules/es6.string.iterator');
require('../../modules/web.dom.iterable');
module.exports = require('../../modules/_wks-ext').f('iterator');



//////////////////
// WEBPACK FOOTER
// ./src/frontend-lib/~/core-js/library/fn/symbol/iterator.js
// module id = 76gX
// module chunks = 0